import { Link } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import AppLayout from '@/components/layout/AppLayout';

export default function BillingCancel() {
  return (
    <AppLayout>
      <div className="container mx-auto px-4 py-12 max-w-md text-center">
        <h1 className="text-2xl font-bold mb-2">Checkout cancelled</h1>
        <p className="text-muted-foreground mb-6">
          You can upgrade anytime from Settings → Billing.
        </p>
        <Button asChild>
          <Link to="/app/settings/billing">Back to Billing</Link>
        </Button>
      </div>
    </AppLayout>
  );
}
